import { TypographyParagraph, TypographyLabel } from '../../typography'
import TypographyHeader from '../../typography/TypographyHeading'
import { LocationIcon, CalendarIcon, RollupIcon, ImageIcon } from '../../icons'
import { formatDateToLongFormat } from '#app/utils/timeUtils'

type RollupExhibitionProps = {
	metadata: {
		event?: {
				eventTitle?: string,
				dateStart?: string,
				dateEnd?: string,
				eventLocation?: string,
				eventDescription?: string,
		},
    properties: {
			attestationCount?: number;
		}
	}
}

export default function RollupExhibition({ metadata }: RollupExhibitionProps) {
  const { properties, event } = metadata;

  return (
    <div className="flex flex-col space-y-2">
      {/* Exhibition Title */}
      <div className="flex items-center space-x-2 text-textPrimaryLight dark:text-textPrimaryDark">
        <TypographyHeader size="small">
          {event?.eventTitle || 'Untitled Rollup Exhibition'}
        </TypographyHeader>
      </div>

      {/* Exhibition Info */}
      {(event?.dateStart || event?.dateEnd) && (
        <div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
          <CalendarIcon size="small" />
          <TypographyParagraph size="small">
            {event.dateStart && formatDateToLongFormat(event.dateStart)}
            {event.dateStart && event.dateEnd && ' - '}
            {event.dateEnd && formatDateToLongFormat(event.dateEnd)}
          </TypographyParagraph>
        </div>
      )}

      {event?.eventLocation && (
        <div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
          <LocationIcon size="small" />
          <TypographyParagraph size="small">
            {event.eventLocation}
          </TypographyParagraph>
        </div>
      )}

      {/* artwork count */}
			{properties.attestationCount && (
				<div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
					<ImageIcon size="small" />
					<TypographyParagraph size="small">
						{properties.attestationCount} artworks
					</TypographyParagraph>
				</div>
			)}

			{/* Rollup description showing eventDescription */}
			{event?.eventDescription && (
        <div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
          <TypographyParagraph size="small">
            {event.eventDescription}
          </TypographyParagraph>
        </div>
      )}
    </div>
  );
} 